import { autoinject, Container, TaskQueue, transient, View, ViewCompiler, ViewResources, metadata } from "aurelia-framework";
import { BaseComponentWrapper, FrameworkComponentWrapper, WrappableInterface } from 'ag-grid-community';
import { HtmlBehaviorResource } from 'aurelia-templating';

@autoinject()
@transient()
export class AureliaFrameworkComponentWrapper extends BaseComponentWrapper<WrappableInterface> implements FrameworkComponentWrapper {
  constructor(private taskQueue: TaskQueue, private _viewCompiler: ViewCompiler, private _container: Container, private _viewResources: ViewResources) {
    super();
  }

  createRenderer(template: string) {
    const that = this;

    // another way of doing this, but to make it work need to figure out how to not register duplicate resources
    // @customElement(`comp-${++this.id}`)
    // @inlineView(template)
    // class Comp {
    //   @bindable
    //   params: any;
    // }

    // const resource = metadata.get(metadata.resource, Comp) as HtmlBehaviorResource;
    // resource.initialize(this._container, Comp);
    // await resource.load(this._container, Comp)
    // resource.register(this._viewResources);
    // resource.

    // // this._viewResources.autoRegister(this._container, Comp);
    // return Comp;

    class DynamicComponent extends BaseGuiComponent implements WrappableInterface {
      constructor() {
        super(that.taskQueue, that._viewCompiler);
      }

      init(params: any): void {
        super.init(params, template, that._viewResources, that._container);
      }

      getValue() {
        return this.callMethod('getValue', arguments);
      }
    }

    return DynamicComponent;
  }

  createWrapper(originalConstructor: { new(): any; }): WrappableInterface {
    let that = this;

    class DynamicComponent extends BaseGuiComponent implements WrappableInterface {
      constructor() {
        super(that.taskQueue, that._viewCompiler);
      }

      init(params: any): void {
        const htmlResource = metadata.getOwn(metadata.resource, originalConstructor) as HtmlBehaviorResource & { elementName: string };
        super.init(params, `<template><${htmlResource.elementName}></${htmlResource.elementName}></template>`, that._viewResources, that._container);
      }
    }

    return new DynamicComponent();
  }

  public setContainer(container: Container): void {
    this._container = container;
  }

  public setViewResources(viewResources: ViewResources): void {
    this._viewResources = viewResources;
  }
}

abstract class BaseGuiComponent {
  private _taskQueue: TaskQueue;
  private _viewCompiler: ViewCompiler;

  protected _params: any;
  protected _view: View;
  private _host: HTMLElement;

  constructor(taskQueue: TaskQueue, viewCompiler: ViewCompiler) {
    this._taskQueue = taskQueue;
    this._viewCompiler = viewCompiler;
  }

  init(params: any, template: any, viewResources: ViewResources, container: Container) {
    this._params = params;

    let bindingContext = { params: params };

    let viewFactory = this._viewCompiler.compile(template, viewResources);
    this._view = viewFactory.create(container);
    this._host = document.createElement('div');
    this._host.classList.add('ag-grid-dynamic-component-host');
    this._host.appendChild(this._view.fragment);
    let controllers: any[] = (<any>this._view).controllers;
    //initialize each controller
    if (controllers && controllers.length) {
      controllers.forEach((c) => {
        c.viewModel.params = params;
      });
      this._view.bind(bindingContext);
      //ICellRenderer doesn't have a guiAttached method so
      //we call attach on the queue;
      this._taskQueue.queueMicroTask(() => this._view.attached());
    }
    else {
      this._view.bind(bindingContext);
    }
  }

  getGui(): HTMLElement {
    return this._host;
    // return this._view.fragment as HTMLElement;
  }


  destroy() {
    this._view.returnToCache();
    this._host = undefined;
  }

  refresh(params: any): boolean {
    return false;
  }

  public getFrameworkComponentInstance(): any {
    let controllers: any[] = (<any>this._view).controllers;

    //only one controller is allowed in editor template
    if (controllers &&
      controllers.length == 1 &&
      controllers[0].viewModel) {
      let editorVm = controllers[0].viewModel;
      //this is a 'hack' because we don't have params.bind="" in the template
      //must reset params or it will be nothing
      editorVm.params = this._params;
      return editorVm;
    }
    return null;
  }

  hasMethod(name: string): boolean {
    return this.getFrameworkComponentInstance() && this.getFrameworkComponentInstance()[name] != null;
  }

  callMethod(name: string, args: IArguments): void {
    const componentRef = this.getFrameworkComponentInstance();
    return this.getFrameworkComponentInstance()[name].apply(componentRef, args)
  }

  addMethod(name: string, callback: Function): void {
    (<any>this)[name] = callback;
  }
}
